import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../app/store";
import { LogInRequest } from "../authModel";
import { postRegister } from "../authentificationSlice";
import { GetServerEmailError, ValidatePasswordContent } from "../../../app/validation";
import { useEmailErrorMessage } from "../../../UIComponents/Form/EmailField";
import { LoadingPage } from "../../CommonPages/loadingPage";
import RegisterCard from "./registerCard";
import { Dialog } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import SuccessCard from "../../CommonPages/successCard";
import { AlertComponent } from "../../../UIComponents/Alert/AlertComponent";
import { Helmet } from "react-helmet-async";

export function Register() {
    const [errorMesssage, seterrorMesssage] = useState('');
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState<string | undefined>();
    const [password, setPassword] = useState('');
    const registerData = useSelector((state: RootState) => state.AuthentificationSlice);
    const { t } = useTranslation();
    const getEmailError = useEmailErrorMessage();
    const dispatch = useDispatch<AppDispatch>();
    const [openDialog, setOpenDialog] = useState(false);
    const [success, setSuccess] = useState(false);
    const [messsage, setMesssage] = useState('');

    const handleOpenDialog = () => setOpenDialog(!openDialog);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        submitFunction(email, password);
    };

    const submitFunction = (email: string, password: string) => {
        const emailProblem = getEmailError(email);
        if (emailProblem) {
            // On the field the user can fix, not in a banner.
            setEmailError(emailProblem);
        }
        else if (!ValidatePasswordContent(password)) {
            seterrorMesssage(t("PasswordFormat"));
            setOpen(true);
        }
        else {
            const registerReq: LogInRequest = { username: email, password: password };
            dispatch(postRegister(registerReq))
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (registerData.statusCode === '200' || registerData.statusCode === 'OK') {
            setSuccess(true);
            setMesssage(t("RequestForAccountCreationWasSentCheckYourEmail"));
            handleOpenDialog();
        }
        else if (registerData.statusCode !== '') {
            // A 400 on the email is the user's typo to fix, so it belongs on the
            // input — not in a dialog they can only dismiss.
            const serverEmailError = GetServerEmailError(registerData.statusCode, registerData.error);
            if (serverEmailError) {
                setEmailError(serverEmailError);
                return;
            }
            setSuccess(false);
            setMesssage(registerData.error ?? t("AnErrorOccurred"));
            handleOpenDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [registerData.statusCode])

    if (registerData.isLoading) {
        return (LoadingPage(registerData.isLoading))
    }

    return (
        <div className="flex justify-center m-[5%]">
            <Helmet>
                <title>BIMAGINE - Sign up for Our Software Solutions!</title>
                <meta name="description" content="Sign up and start using our Software Solutions" />
                <link rel="canonical" href={"https://www.bimagine.com/register"} />
            </Helmet>
            <form className="space-y-5" onSubmit={handleSubmit}>
                {errorMesssage !== "" ?
                    <AlertComponent open={open} onClose={() => setOpen(false)} message={errorMesssage} />
                    : <></>}
                <RegisterCard onClickFunction={submitFunction} setEmailForm={setEmail} setPasswordForm={setPassword} emailError={emailError} onEmailErrorClear={() => setEmailError(undefined)} />
                <input type="submit" style={{ display: "none" }} />
            </form>
            <Dialog open={openDialog} handler={handleOpenDialog} size="xs" animate={{ mount: { scale: 1, y: 0 }, unmount: { scale: 0.9, y: -100 } }}>
                <SuccessCard onClickFunction={handleOpenDialog} text={messsage} success={success} />
            </Dialog>
        </div>
    )
}
